import { type AccountInfo, InteractionRequiredAuthError, PublicClientApplication } from '@azure/msal-browser';
import { apiScopes, clearSession, createMsalConfig, loadSession } from '@servicedesk/ui';
import { authConfigured, authMode, authRedirectUri, basePath, config } from '../config';

/** Null in local dev mode (Entra not configured); a real client otherwise. */
export const msalInstance: PublicClientApplication | null = authConfigured
  ? new PublicClientApplication(createMsalConfig({ ...config.entra, redirectUri: authRedirectUri }))
  : null;

export const loginRequest = { scopes: apiScopes(config.entra) };

export async function acquireApiToken(): Promise<string> {
  if (!msalInstance) return '';
  const account: AccountInfo | undefined =
    msalInstance.getActiveAccount() ?? msalInstance.getAllAccounts()[0] ?? undefined;
  try {
    const result = await msalInstance.acquireTokenSilent({ ...loginRequest, account });
    return result.accessToken;
  } catch (err) {
    if (err instanceof InteractionRequiredAuthError) {
      await msalInstance.acquireTokenRedirect(loginRequest);
    }
    throw err;
  }
}

export function accountName(): string {
  if (authMode === 'magic') {
    const s = loadSession();
    return s?.user.name ?? s?.user.email ?? '';
  }
  if (!msalInstance) return 'Dev User';
  const a = msalInstance.getActiveAccount();
  return a?.name ?? a?.username ?? '';
}

export function signOut(): void {
  if (authMode === 'magic') {
    clearSession();
    window.location.href = basePath;
    return;
  }
  if (!msalInstance) {
    window.location.reload();
    return;
  }
  void msalInstance.logoutRedirect();
}
